import { render, staticRenderFns } from "./ViewAiBusinessPromoter.vue?vue&type=template&id=4b7235d9&scoped=true&"
import script from "./ViewAiBusinessPromoter.vue?vue&type=script&lang=js&"
export * from "./ViewAiBusinessPromoter.vue?vue&type=script&lang=js&"
import style0 from "./ViewAiBusinessPromoter.vue?vue&type=style&index=0&id=4b7235d9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b7235d9",
  null
  
)

export default component.exports